const currentDate = new Date(); // Get the current date
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth() + 1; // Adding 1 as January is 0 in JavaScript Date

export const startOfMonth = new Date(`${currentYear}-${currentMonth}-01`);
export const endOfMonth = new Date(
  `${currentMonth === 12 ? currentYear + 1 : currentYear}-${
    currentMonth === 12 ? "01" : currentMonth + 1
  }-01`
);
